<template>
    <div id="app" class="font-main">
        <router-view :key="$route.path" />
    </div>
</template>
<script>
import ConfigManager from '@/config/ConfigManager.js';
export default {
    created: function(){
        let appId = this.$route.query?.app_id ? this.$route.query.app_id : null
        console.log(this.$route)
        if(!ConfigManager.getAppId()){
            ConfigManager.setAppId(appId);
        }
        console.log(ConfigManager.getAppId())
    }
}
</script>

<style lang="scss">
@import "@/style/main.scss";

</style>
